import React, { useState } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { numDifferentiationWithoutSymbol } from "../../CommonMethhods/CovertRupees";
import LoaderForSearch from "../Common/LoaderForSearch";

function TentativeMarginTable(props) {
  const elseError = props.error;
  let gridVal = props.gridVal;
  const handleScroll = props.handleScroll;
  const scrollLoader = props.scrollLoader;

  const showTentativeMargin = (gridVal) => {
    return (
      gridVal &&
      gridVal.map((item, key) => {
        return (
          <tr key={key}>
            <td>
              {item.tradeDate === "" || undefined || null
                ? "-"
                : item.tradeDate}
            </td>
            <td>
              {item.clientCode === "" || undefined || null
                ? "-"
                : item.clientCode}
            </td>
            {/* <td>{item.ucid === "" || undefined || null ? "-" : item.ucid}</td> */}
            <td>
              {item.clientName === "" || undefined || null
                ? "-"
                : item.clientName}
            </td>
            <td>
              {item.edtLedgerBal === "" || undefined || null
                ? "-"
                : item.edtLedgerBal}
            </td>
            <td>
              {item.nonCashCollateral === "" || undefined || null
                ? "-"
                : item.nonCashCollateral}
            </td>
            <td>
              {item.cashCollateral === "" || undefined || null
                ? "-"
                : item.cashCollateral}
            </td>
            <td>
              {item.unClearedCheq === "" || undefined || null
                ? "-"
                : item.unClearedCheq}
            </td>
            <td>{item.epn === "" || undefined || null ? "-" : item.epn}</td>
            <td>
              {item.sellCredit === "" || undefined || null
                ? "-"
                : item.sellCredit}
            </td>
            <td>
              {item.AvailBal === "" || undefined || null ? "-" : item.AvailBal}
            </td>
            <td>
              {item.eodFoReq === "" || undefined || null ? "-" : item.eodFoReq}
            </td>
            <td>
              {item.eodCashReq === "" || undefined || null
                ? "-"
                : item.eodCashReq}
            </td>
            <td>
              {item.eodPeakMargin === "" || undefined || null
                ? "-"
                : item.eodPeakMargin}
            </td>
            <td>
              {item.totalEodMargin === "" || undefined || null
                ? "-"
                : item.totalEodMargin}
            </td>
            <td>
              {item.exchangeShortFall === "" || undefined || null
                ? "-"
                : item.exchangeShortFall}
            </td>
            <td>
              {item.eodShortExcess === "" || undefined || null
                ? "-"
                : item.eodShortExcess}
            </td>
            <td>
              {item.peakEodShortExcess === "" || undefined || null
                ? "-"
                : item.peakEodShortExcess}
            </td>
            <td>
              {item.cashPeakMargin === "" || undefined || null
                ? "-"
                : item.cashPeakMargin}
            </td>
            <td>
              {item.foPeakMargin === "" || undefined || null
                ? "-"
                : item.foPeakMargin}
            </td>
            <td>
              {item.branchCode === "" || undefined || null
                ? "-"
                : item.branchCode}
            </td>
            <td>
              {item.rmName === "" || undefined || null ? "-" : item.rmName}
            </td>
            <td>
              {item.rmEmail === "" || undefined || null ? "-" : item.rmEmail}
            </td>
          </tr>
        );
      })
    );
  };
  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper ">
        {gridVal && gridVal ? (
          <table className="table last-column">
            <thead>
              <tr>
                <th scope="col" className="text-center">
                  Trade Date
                </th>
                <th scope="col">{Constants.Client_Code}</th>
                {/* <th scope="col" className="text-center">
                  UCID
                </th> */}
                <th scope="col" className="text-center">
                  {Constants.client_Name}
                </th>
                <th scope="col" className="text-center">
                  EDT Ledger Balance
                </th>
                <th scope="col" className="text-center">
                  Non Cash Collateral
                </th>
                <th scope="col" className="text-center">
                  Cash Collateral
                </th>
                <th scope="col" className="text-center">
                  Uncleared Cheq
                </th>
                <th scope="col" className="text-center">
                  EPN
                </th>
                <th scope="col" className="text-center">
                  Sell Credit
                </th>
                <th scope="col" className="text-center">
                  Available Balance
                </th>
                <th scope="col" className="text-center">
                  EOD FO Required
                </th>
                <th scope="col" className="text-center">
                  EOD Cash Required
                </th>
                <th scope="col" className="text-center">
                  EOD Peak Margin
                </th>
                <th scope="col" className="text-center">
                  Total EOD Margin
                </th>
                <th scope="col" className="text-center">
                  Exchange Shortfall
                </th>
                <th scope="col" className="text-center">
                  EOD Short Excess
                </th>
                <th scope="col" className="text-center">
                  Peak EOD Short Excess
                </th>
                <th scope="col" className="text-center">
                  Cash Peak Margin
                </th>
                <th scope="col" className="text-center">
                  FO Peak Margin
                </th>
                <th scope="col" className="text-center">
                  Branch Code
                </th>
                <th scope="col" className="text-center">
                  RM Name
                </th>
                <th scope="col" className="text-center">
                  RM Email
                </th>
              </tr>
            </thead>
            <tbody id="tentative-scroll" onScroll={handleScroll}>
              {showTentativeMargin(gridVal)}
              {scrollLoader && (
                <div className="loader-center">
                  <LoaderForSearch />
                </div>
              )}
            </tbody>
          </table>
        ) : (
          ""
          // <div className="report-error-message">{props.elseError}</div>
        )}
      </div>
    </>
  );
}
export default TentativeMarginTable;
